/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Invoice_NoInputs */

const en_admin_external_booking_edit_invoice_no = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice No.:`)
};

const de_admin_external_booking_edit_invoice_no = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungsnr.:`)
};

const es_admin_external_booking_edit_invoice_no = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N.º de factura:`)
};

const fr_admin_external_booking_edit_invoice_no = /** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N° de facture :`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */
const it_admin_external_booking_edit_invoice_no = en_admin_external_booking_edit_invoice_no;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_invoice_no = en_admin_external_booking_edit_invoice_no;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */
const pl_admin_external_booking_edit_invoice_no = en_admin_external_booking_edit_invoice_no;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */
const hu_admin_external_booking_edit_invoice_no = en_admin_external_booking_edit_invoice_no;

/** @type {(inputs: Admin_External_Booking_Edit_Invoice_NoInputs) => LocalizedString} */
const ro_admin_external_booking_edit_invoice_no = en_admin_external_booking_edit_invoice_no;

/**
* | output |
* | --- |
* | "Invoice No.:" |
*
* @param {Admin_External_Booking_Edit_Invoice_NoInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_invoice_no = /** @type {((inputs?: Admin_External_Booking_Edit_Invoice_NoInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Invoice_NoInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_invoice_no(inputs)
	if (locale === "de") return de_admin_external_booking_edit_invoice_no(inputs)
	if (locale === "es") return es_admin_external_booking_edit_invoice_no(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_invoice_no(inputs)
	if (locale === "it") return it_admin_external_booking_edit_invoice_no(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_invoice_no(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_invoice_no(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_invoice_no(inputs)
	return ro_admin_external_booking_edit_invoice_no(inputs)
});
export { admin_external_booking_edit_invoice_no as "admin.external_booking_edit.invoice_no" }